if (!customElements.get("quick-view-modal")) {
  customElements.define(
    "quick-view-modal",
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: "quick-view-loaded",
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return ".quick-view__content";
      }

      get sourceSelector() {
        return "#MainProduct-quick-view__content";
      }

      prepareToShow() {
        if (super.prepareToShow) super.prepareToShow();
        this.quickview();
      }

      quickview() {
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();

        if (!this.dataset.productUrl) return;

        const sectionUrl = `${this.dataset.productUrl.split("?")[0]}?section_id=${sectionId}`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const sourceElement = html.querySelector(this.sourceSelector);

            if (sourceElement) {
              const contentHtml =
                sourceElement.tagName === "TEMPLATE"
                  ? sourceElement.innerHTML
                  : sourceElement.outerHTML;

              this.setInnerHTML(drawerContent, contentHtml);
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            setTimeout(() => {
              this.classList.add(this._classes.loaded);
            }, 300);

            if (
              FoxTheme.a11y &&
              typeof FoxTheme.a11y.trapFocus === "function"
            ) {
              FoxTheme.a11y.trapFocus(this);
            }

            document.dispatchEvent(
              new CustomEvent("quick-view:loaded", {
                detail: { productUrl: this.dataset.productUrl },
              }),
            );
          })
          .catch((e) => {
            console.error("Quick View Fetch Error:", e);
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        element.querySelectorAll("script").forEach((oldScript) => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes).forEach((attr) =>
            newScript.setAttribute(attr.name, attr.value),
          );
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        const productInfo = element.querySelector("product-info");
        if (productInfo && productInfo.init) {
          productInfo.init();
        }

        if (window.FoxTheme && window.FoxTheme.init) {
          window.FoxTheme.init(element);
        }
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          const productQuickView = document.querySelector(
            ".section-group-overlay-quick-view",
          );
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      handleAfterHide() {
        if (super.handleAfterHide) super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        if (drawerContent) drawerContent.innerHTML = "";
        this.classList.remove(this._classes.loaded);
      }
    },
  );
}
